import { Home } from 'components/Home';

const ScreenHome = () => {
  return <Home />;
};

export default ScreenHome;
